import { render, staticRenderFns } from "./productTable.vue?vue&type=template&id=a991e7be&scoped=true"
import script from "./productTable.vue?vue&type=script&lang=js"
export * from "./productTable.vue?vue&type=script&lang=js"
import style0 from "./productTable.vue?vue&type=style&index=0&id=a991e7be&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a991e7be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a991e7be')) {
      api.createRecord('a991e7be', component.options)
    } else {
      api.reload('a991e7be', component.options)
    }
    module.hot.accept("./productTable.vue?vue&type=template&id=a991e7be&scoped=true", function () {
      api.rerender('a991e7be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dms/views/personaAndCompany/personalInfo/form/components/productTable.vue"
export default component.exports